import { render, staticRenderFns } from "./AddProductQuicklyComponent.vue?vue&type=template&id=a01cbe16&"
import script from "./AddProductQuicklyComponent.vue?vue&type=script&lang=js&"
export * from "./AddProductQuicklyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VImg,VListItemAction,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle})
